import React from 'react'
import I18n from 'lib/i18n'

export default function SlideTwo ({ slideIndex }) {
  const style = slideIndex === 2 ? { display: 'flex', justifyContent: 'space-between' } : { display: 'none' }

  return (
    <div className='slide.slide-2' style={style}>
      <div className='left-par not-responsive'>
        <div className='not-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto' }}>
          <img
            className='lazyload'
            data-src={`/assets/pages/how1/student-profile-${I18n.locale === 'fr' ? 'fr' : 'en'}.png`}
            data-retina={`/assets/pages/how1/student-profile-${I18n.locale == 'fr' ? 'fr' : 'en'}@2x.png`}
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
      </div>
      <div className='right-part'>
        <h3 dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.students_2_title') }} />
        <div className='only-responsive-inline-block' style={{ maxWidth: 410, margin: '0 auto', marginBottom: 10 }}>
          <img
            className='lazyload'
            data-src={`/assets/pages/how1/student-profile-${I18n.locale === 'fr' ? 'fr' : 'en'}.png`}
            data-retina={`/assets/pages/how1/student-profile-${I18n.locale == 'fr' ? 'fr' : 'en'}@2x.png`}
            style={{ maxWidth: '100%', width: 'auto !important', height: 'auto !important' }}
            alt=''
          />
        </div>
        <div dangerouslySetInnerHTML={{ __html: I18n.t('pages.how1.students_2') }} />
      </div>
    </div>
  )
}
